/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService, environment } from '@perval/shared';
import { firstValueFrom } from 'rxjs';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class ExportConsumptionTrackingCsvService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-credits/spendings_and_credits/export`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  public async exportConsumptionTrackingCsv(
    start: Date,
    end: Date,
  ): Promise<string | Blob> {
    try {
      const response = await firstValueFrom(
        this.http.get(
          `${this.mainUrl}?start_date=${format(
            start,
            'yyyy-MM-dd',
          )}&end_date=${format(end, 'yyyy-MM-dd')}`,
          {
            headers:
              await this.httpHeadersServiceService.getHeadersWithPervalContext(),
            observe: 'response',
            responseType: 'blob',
          },
        ),
      );

      if (
        response.status === 200 &&
        response.headers.get('content-type') === 'text/csv'
      ) {
        return response.body as Blob;
      } else if (response.status === 202) {
        return "Le fichier va être généré. Cela peut prendre jusqu'à 5 minutes pour un mois. Vous recevrez un e-mail quand le processus sera terminé.";
      } else {
        return 'Réponse inattendue du serveur';
      }
      // TODO : gérer les erreurs correctement dans NPER-812
    } catch (error: any) {
      if (error.status === 429) {
        return "Le fichier est actuellement en cours de génération. Veuillez patienter, s'il vous plaît.";
      } else {
        throw new Error(await this.handleHttpError(error));
      }
    }
  }

  private async handleHttpError(error: any): Promise<string> {
    let errorMessage = "Erreur lors de l'export du fichier CSV";

    try {
      if (error.error instanceof Blob) {
        const text = await error.error.text();

        if (text) {
          try {
            const errorJson = JSON.parse(text);

            if (
              errorJson &&
              errorJson.httpStatus === 'BAD_REQUEST' &&
              errorJson?.errors[0]?.field
            ) {
              errorMessage = errorJson.errors[0].message;
            }
          } catch {
            console.error("Le texte n'est pas un JSON valide:", text);
            return errorMessage;
          }
        }
      }
      // TODO : gérer les erreurs correctement dans NPER-812
    } catch (e: any) {
      console.error("Erreur lors du traitement de l'erreur:", e);
      return errorMessage;
    }

    return errorMessage;
  }
}
